import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import TemplateForm from "../../ui/TemplateForm/TemplateForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  getEditingTemplateAsync,
  editTemplateAsync,
  clearTemplateForm,
} from "../../../redux/actions/editTemplate";

import {
  openCancelModal,
  closeCancelModal,
} from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editTemplate,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: templateId => dispatch(push(`/template/${templateId}`)),
  onEditTemplate: templateId => dispatch(editTemplateAsync(templateId)),
  getTemplateInfo: templateId => dispatch(getEditingTemplateAsync(templateId)),
  clearForm: () => dispatch(clearTemplateForm()),
});

class EditTemplate extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    template: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
    onEditTemplate: PropTypes.func.isRequired,
    getTemplateInfo: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { getTemplateInfo } = this.props;
    const templateId = this.props.match.params.templateId;
    getTemplateInfo(templateId);
  }

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    const templateId = this.props.match.params.templateId;
    closeCancelModal();
    clearForm();
    onGoBack(templateId);
  }

  render() {
    const {
      ready,
      loading,
      template,
      cancelModal,
      openCancelModal,
      closeCancelModal,
      onEditTemplate,
    } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
        confirmText="Остаться"
        cancelText="Покинуть страницу"
        modal={cancelModal}
        onSubmit={() => closeCancelModal()}
        onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => openCancelModal()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span>
            </button>
          ) : false}
        </div>
        
        <div className="page-content forms">
          <div className="form-header">Изменение шаблона</div>
          {ready ? (
            <TemplateForm
              edit
              template={template}
              submitText="Сохранить изменения"
              onSubmit={() => onEditTemplate(template.id)}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(EditTemplate));
